import React from 'react';
import { Collapse } from 'antd/lib';
const Panel = Collapse.Panel;

class LeyendaVariables extends React.Component {
  render() {
    return (
      <Collapse>
        <Panel header="Para datos de fecha" key="0">
          <p>
            <strong>#dias#</strong>: Representa el dia actual
          </p>
          <p>
            <strong>#mes#</strong>: Representa el mes actual
          </p>
          <p>
            <strong>#anio#</strong>: Representa el año actual
          </p>
        </Panel>
        <Panel header="Para datos del organismo" key="7">
          <p>
            <strong>#organismo.nombre#</strong>: Representa el nombre del
            organismo que realiza la nota
          </p>
          <p>
            <strong>#organismo.ciudad#</strong>: Representa la ciudad donde se
            encuentra el organismo
          </p>
          <p>
            <strong>#organismo.direccion#</strong>: Representa la calle donde se
            encuentra el organismo
          </p>
          <p>
            <strong>#organismo.telefono#</strong>: Representa el telefono del
            organismo
          </p>
        </Panel>
        <Panel header="Para las declaraciones juradas" key="1">
          <Collapse>
            <Panel header="Para datos de las personas" key="1">
              <p>
                <strong>#tipo_doc#</strong>: Representa el tipo de documento de
                la persona{' '}
              </p>
              <p>
                <strong>#num_doc#</strong>: Representa el numero de documento de
                la persona{' '}
              </p>
              <p>
                <strong>#nombre#</strong>: Representa el nombre de la persona
              </p>
              <p>
                <strong>#apellido#</strong>: Representa el apellido de la
                persona
              </p>

              <p>
                <strong>#fecha_nacimiento#</strong>: Representa la fecha de
                nacimiento de la persona
              </p>

              <p>
                <strong>#domicilio#</strong>: Representa el domicilio de la
                persona{' '}
              </p>
              <p>
                <strong>#nacionalidad#</strong>: Representa la nacionalidad de
                la persona{' '}
              </p>
              <p>
                <strong>#edad#</strong>: Representa la edad de la persona{' '}
              </p>

              <p>
                <strong>#telefono#</strong>: Representa el telefono de la
                persona{' '}
              </p>
              <p>
                <strong>#profesion#</strong>: Representa la profesion de la
                persona{' '}
              </p>
              <p>
                <strong>#educacion#</strong>: Representa el nivel de educacion
                de la persona{' '}
              </p>
              <p>
                <strong>#estado_civil#</strong>: Representa el estado civil de
                la persona{' '}
              </p>

              <p>
                <strong>#domicilio#</strong>: Representa el domicilio de la
                persona{' '}
              </p>

              <p>
                <strong>#localidad#</strong>: Representa la localidad de la
                persona{' '}
              </p>
            </Panel>

            <Panel header="Propios de la declaracion jurada" key="2">
              <p>
                <strong>#declaracion#</strong>: Representa lo que la persona
                declaró
              </p>
              <p>
                <strong>#ente_receptor#</strong>: Representa que ente será el
                receptor de la nota
              </p>
            </Panel>
          </Collapse>
        </Panel>

        <Panel header="Para las autorizaciones de viajes" key="2">
          <Collapse>
            <Panel header="Para datos del AUTORIZADO" key="1">
              <p>
                <strong>#autorizado.tipo_doc#</strong>: Representa el tipo de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#autorizado.num_doc#</strong>: Representa el numero de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#autorizado.nombre#</strong>: Representa el nombre de la
                persona
              </p>
              <p>
                <strong>#autorizado.apellido#</strong>: Representa el apellido
                de la persona
              </p>

              <p>
                <strong>#autorizado.fecha_nacimiento#</strong>: Representa la
                fecha de nacimiento de la persona
              </p>

              <p>
                <strong>#autorizado.domicilio#</strong>: Representa el domicilio
                de la persona{' '}
              </p>
              <p>
                <strong>#autorizado.nacionalidad#</strong>: Representa la
                nacionalidad de la persona{' '}
              </p>
              <p>
                <strong>#autorizado.edad#</strong>: Representa la edad de la
                persona{' '}
              </p>

              <p>
                <strong>#autorizado.telefono#</strong>: Representa el telefono
                de la persona{' '}
              </p>
              <p>
                <strong>#autorizado.profesion#</strong>: Representa la profesion
                de la persona{' '}
              </p>
              <p>
                <strong>#autorizado.educacion#</strong>: Representa el nivel de
                educacion de la persona{' '}
              </p>
              <p>
                <strong>#autorizado.estado_civil#</strong>: Representa el estado
                civil de la persona{' '}
              </p>

              <p>
                <strong>#autorizado.domicilio#</strong>: Representa el domicilio
                de la persona{' '}
              </p>

              <p>
                <strong>#autorizado.localidad#</strong>: Representa la localidad
                de la persona{' '}
              </p>
            </Panel>

            <Panel header="Para datos del AUTORIZANTE" key="2">
              <p>
                <strong>#autorizante.tipo_doc#</strong>: Representa el tipo de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#autorizante.num_doc#</strong>: Representa el numero de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#autorizante.nombre#</strong>: Representa el nombre de
                la persona
              </p>
              <p>
                <strong>#autorizante.apellido#</strong>: Representa el apellido
                de la persona
              </p>

              <p>
                <strong>#autorizante.fecha_nacimiento#</strong>: Representa la
                fecha de nacimiento de la persona
              </p>

              <p>
                <strong>#autorizante.domicilio#</strong>: Representa el
                domicilio de la persona{' '}
              </p>
              <p>
                <strong>#autorizante.nacionalidad#</strong>: Representa la
                nacionalidad de la persona{' '}
              </p>
              <p>
                <strong>#autorizante.edad#</strong>: Representa la edad de la
                persona{' '}
              </p>

              <p>
                <strong>#autorizante.telefono#</strong>: Representa el telefono
                de la persona{' '}
              </p>
              <p>
                <strong>#autorizante.profesion#</strong>: Representa la
                profesion de la persona{' '}
              </p>
              <p>
                <strong>#autorizante.educacion#</strong>: Representa el nivel de
                educacion de la persona{' '}
              </p>
              <p>
                <strong>#autorizante.estado_civil#</strong>: Representa el
                estado civil de la persona{' '}
              </p>

              <p>
                <strong>#autorizante.domicilio#</strong>: Representa el
                domicilio de la persona{' '}
              </p>

              <p>
                <strong>#autorizante.localidad#</strong>: Representa la
                localidad de la persona{' '}
              </p>
            </Panel>

            <Panel header="Para datos del RESPONSABLE" key="3">
              <p>
                <strong>#responsable.tipo_doc#</strong>: Representa el tipo de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#responsable.num_doc#</strong>: Representa el numero de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#responsable.nombre#</strong>: Representa el nombre de
                la persona
              </p>
              <p>
                <strong>#responsable.apellido#</strong>: Representa el apellido
                de la persona
              </p>

              <p>
                <strong>#responsable.fecha_nacimiento#</strong>: Representa la
                fecha de nacimiento de la persona
              </p>

              <p>
                <strong>#responsable.domicilio#</strong>: Representa el
                domicilio de la persona{' '}
              </p>
              <p>
                <strong>#responsable.nacionalidad#</strong>: Representa la
                nacionalidad de la persona{' '}
              </p>
              <p>
                <strong>#responsable.edad#</strong>: Representa la edad de la
                persona{' '}
              </p>

              <p>
                <strong>#responsable.telefono#</strong>: Representa el telefono
                de la persona{' '}
              </p>
              <p>
                <strong>#responsable.profesion#</strong>: Representa la
                profesion de la persona{' '}
              </p>
              <p>
                <strong>#responsable.educacion#</strong>: Representa el nivel de
                educacion de la persona{' '}
              </p>
              <p>
                <strong>#responsable.estado_civil#</strong>: Representa el
                estado civil de la persona{' '}
              </p>

              <p>
                <strong>#responsable.domicilio#</strong>: Representa el
                domicilio de la persona{' '}
              </p>

              <p>
                <strong>#responsable.localidad#</strong>: Representa la
                localidad de la persona{' '}
              </p>
            </Panel>

            <Panel header="Propios de la autorizacion en si" key="4">
              {/* <p>
                <strong>#tipo_autorizacion#</strong>: Representa el tipo de autorizacion
              </p> */}
              <p>
                <strong>#vinculo_autorizante#</strong>: Representa el vinculo
                entre los involucrados
              </p>
              <p>
                <strong>#numero_acta_nacimiento#</strong>: Representa el numero
                de acta de nacimiento del autorizado
              </p>
              <p>
                <strong>#cantidad_dias#</strong>: Representa la cantidad de dias
                que tendrá vigencia la autorizacion
              </p>
            </Panel>
          </Collapse>
        </Panel>

        <Panel header="Para las autorizaciones genericas" key="3">
          <Collapse>
            <Panel header="Para datos de las personas" key="1">
              <p>
                <strong>#nombre#</strong>: Representa el nombre de la persona
              </p>
              <p>
                <strong>#apellido#</strong>: Representa el apellido de la
                persona
              </p>
              <p>
                <strong>#tipo_doc#</strong>: Representa el tipo de documento de
                la persona{' '}
              </p>
              <p>
                <strong>#num_doc#</strong>: Representa el numero de documento de
                la persona{' '}
              </p>
              <p>
                <strong>#domicilio#</strong>: Representa el domicilio de la
                persona{' '}
              </p>
              <p>
                <strong>#nacionalidad#</strong>: Representa la nacionalidad de
                la persona{' '}
              </p>
              <p>
                <strong>#edad#</strong>: Representa la edad de la persona{' '}
              </p>
              <p>
                <strong>#profesion#</strong>: Representa la profesion de la
                persona{' '}
              </p>
              <p>
                <strong>#educacion#</strong>: Representa el nivel de educacion
                de la persona{' '}
              </p>
              <p>
                <strong>#estado_civil#</strong>: Representa el estado civil de
                la persona{' '}
              </p>
            </Panel>
            <Panel header="Propios de la autorizacion en si" key="2">
              <p>
                <strong>#autorizacion#</strong>: Representa lo que se va a
                autorizar
              </p>
              <p>
                <strong>#ente_receptor#</strong>: Representa el ente receptor
                que recibirá la autorizacion
              </p>
            </Panel>
          </Collapse>
        </Panel>

        <Panel header="Para los casos de violencia de genero" key="4">
          <Collapse>
            <Panel header="Para datos de las victimas" key="1">
              <p>
                <strong>#victima.nombre#</strong>: Representa el nombre de la
                persona
              </p>
              <p>
                <strong>#victima.apellido#</strong>: Representa el apellido de
                la persona
              </p>
              <p>
                <strong>#victima.tipo_doc#</strong>: Representa el tipo de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#victima.num_doc#</strong>: Representa el numero de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#victima.domicilio#</strong>: Representa el domicilio de
                la persona{' '}
              </p>
              <p>
                <strong>#victima.nacionalidad#</strong>: Representa la
                nacionalidad de la persona{' '}
              </p>
              <p>
                <strong>#victima.edad#</strong>: Representa la edad de la
                persona{' '}
              </p>
              <p>
                <strong>#victima.profesion#</strong>: Representa la profesion de
                la persona{' '}
              </p>
              <p>
                <strong>#victima.educacion#</strong>: Representa el nivel de
                educacion de la persona{' '}
              </p>
              <p>
                <strong>#victima.estado_civil#</strong>: Representa el estado
                civil de la persona{' '}
              </p>
            </Panel>

            <Panel header="Para datos del agresor" key="2">
              <p>
                <strong>#agresor.nombre#</strong>: Representa el nombre de la
                persona
              </p>
              <p>
                <strong>#agresor.apellido#</strong>: Representa el apellido de
                la persona
              </p>
              <p>
                <strong>#agresor.tipo_doc#</strong>: Representa el tipo de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#agresor.num_doc#</strong>: Representa el numero de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#agresor.domicilio#</strong>: Representa el domicilio de
                la persona{' '}
              </p>
              <p>
                <strong>#agresor.nacionalidad#</strong>: Representa la
                nacionalidad de la persona{' '}
              </p>
              <p>
                <strong>#agresor.edad#</strong>: Representa la edad de la
                persona{' '}
              </p>
              <p>
                <strong>#agresor.profesion#</strong>: Representa la profesion de
                la persona{' '}
              </p>

              <p>
                <strong>#agresor.educacion#</strong>: Representa el nivel de
                educacion de la persona{' '}
              </p>
              <p>
                <strong>#agresor.estado_civil#</strong>: Representa el estado
                civil de la persona{' '}
              </p>
            </Panel>
          </Collapse>
        </Panel>
        <Panel header="Para los acuerdos extrajudiciales" key="5">
          <Collapse>
            <Panel header="Para datos del Requirente" key="1">
              <p>
                <strong>#requirente.nombre#</strong>: Representa el nombre de la
                persona
              </p>
              <p>
                <strong>#requirente.apellido#</strong>: Representa el apellido
                de la persona
              </p>
              <p>
                <strong>#requirente.tipo_doc#</strong>: Representa el tipo de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#requirente.num_doc#</strong>: Representa el numero de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#requirente.domicilio#</strong>: Representa el domicilio
                de la persona{' '}
              </p>
              <p>
                <strong>#requirente.nacionalidad#</strong>: Representa la
                nacionalidad de la persona{' '}
              </p>
              <p>
                <strong>#requirente.edad#</strong>: Representa la edad de la
                persona{' '}
              </p>
              <p>
                <strong>#requirente.profesion#</strong>: Representa la profesion
                de la persona{' '}
              </p>
              <p>
                <strong>#requirente.educacion#</strong>: Representa el nivel de
                educacion de la persona{' '}
              </p>
              <p>
                <strong>#requirente.estado_civil#</strong>: Representa el estado
                civil de la persona{' '}
              </p>
            </Panel>

            <Panel header="Para datos de los Requeridos" key="2">
              {/* REQUERIDO 1 */}
              <p>
                <strong>#requerido1.nombre#</strong>: Representa el nombre de la
                persona
              </p>
              <p>
                <strong>#requerido1.apellido#</strong>: Representa el apellido
                de la persona
              </p>
              <p>
                <strong>#requerido1.tipo_doc#</strong>: Representa el tipo de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#requerido1.num_doc#</strong>: Representa el numero de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#requerido1.domicilio#</strong>: Representa el domicilio
                de la persona{' '}
              </p>
              <p>
                <strong>#requerido1.nacionalidad#</strong>: Representa la
                nacionalidad de la persona{' '}
              </p>
              <p>
                <strong>#requerido1.edad#</strong>: Representa la edad de la
                persona{' '}
              </p>
              <p>
                <strong>#requerido1.profesion#</strong>: Representa la profesion
                de la persona{' '}
              </p>
              <p>
                <strong>#requerido1.educacion#</strong>: Representa el nivel de
                educacion de la persona{' '}
              </p>
              <p>
                <strong>#requerido1.estado_civil#</strong>: Representa el estado
                civil de la persona{' '}
              </p>
              {/* REQUERIDO 2 */}
              <p>
                <strong>#requerido2.nombre#</strong>: Representa el nombre de la
                persona
              </p>
              <p>
                <strong>#requerido2.apellido#</strong>: Representa el apellido
                de la persona
              </p>
              <p>
                <strong>#requerido2.tipo_doc#</strong>: Representa el tipo de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#requerido2.num_doc#</strong>: Representa el numero de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#requerido2.domicilio#</strong>: Representa el domicilio
                de la persona{' '}
              </p>
              <p>
                <strong>#requerido2.nacionalidad#</strong>: Representa la
                nacionalidad de la persona{' '}
              </p>
              <p>
                <strong>#requerido2.edad#</strong>: Representa la edad de la
                persona{' '}
              </p>
              <p>
                <strong>#requerido2.profesion#</strong>: Representa la profesion
                de la persona{' '}
              </p>
              <p>
                <strong>#requerido2.educacion#</strong>: Representa el nivel de
                educacion de la persona{' '}
              </p>
              <p>
                <strong>#requerido2.estado_civil#</strong>: Representa el estado
                civil de la persona{' '}
              </p>
              {/* REQUERIDO 3 */}
              <p>
                <strong>#requerido3.nombre#</strong>: Representa el nombre de la
                persona
              </p>
              <p>
                <strong>#requerido3.apellido#</strong>: Representa el apellido
                de la persona
              </p>
              <p>
                <strong>#requerido3.tipo_doc#</strong>: Representa el tipo de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#requerido3.num_doc#</strong>: Representa el numero de
                documento de la persona{' '}
              </p>
              <p>
                <strong>#requerido3.domicilio#</strong>: Representa el domicilio
                de la persona{' '}
              </p>
              <p>
                <strong>#requerido3.nacionalidad#</strong>: Representa la
                nacionalidad de la persona{' '}
              </p>
              <p>
                <strong>#requerido3.edad#</strong>: Representa la edad de la
                persona{' '}
              </p>
              <p>
                <strong>#requerido3.profesion#</strong>: Representa la profesion
                de la persona{' '}
              </p>
              <p>
                <strong>#requerido3.educacion#</strong>: Representa el nivel de
                educacion de la persona{' '}
              </p>
              <p>
                <strong>#requerido3.estado_civil#</strong>: Representa el estado
                civil de la persona{' '}
              </p>
            </Panel>
            <Panel header="Propios del Acuerdo Extrajudicial" key="3">
              <p>
                <strong>#motivo#</strong>: Representa el motivo de la solicitud
                del acuerdo
              </p>
              <p>
                <strong>#acuerdo.numero#</strong>: Representa el numero del
                tramite
              </p>
            </Panel>
          </Collapse>
        </Panel>
      </Collapse>
    );
  }
}

export default LeyendaVariables;
